import t from "./highrise1768.mjs";
import r from "./highrise1769.mjs";
var a = r(t);
export {
  a as default
};
